<template>
  <v-app>
    <v-app-bar
      app
      flat
      dark
      v-if="$vuetify.breakpoint.mdAndUp"
      :color="bg"
    >
      <div class="d-flex display-text-normal align-center">
        <v-icon size="40" class="pr-4">mdi-watering-can</v-icon>

        communitree
      </div>

      <v-spacer></v-spacer>

      <v-btn
        text
        @click="scrollToClass('.how-it-works-area')"
      >
        <span class="mr-2">How it works</span>
      </v-btn>
      <v-btn
        text
        @click="scrollToClass('.cities-area')"
      >
        <span class="mr-2">Our cities</span>
      </v-btn>
      <v-btn
        text
        @click="scrollToClass('.new-city-area')"
      >
        <span class="mr-2">Start in a new city</span>
      </v-btn>
      <v-btn
        text
      >
        <span class="mr-2">Team</span>
      </v-btn>
    </v-app-bar>

    <v-main class="ma-0 pa-0">
      <router-view/>
    </v-main>
  </v-app>
</template>

<style>
  @import './style.css';
</style>

<script>

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    bg: 'transparent'
  }),
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
  },
  methods: {
    changeColor() {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        this.bg = 'darkgrey';
      } else {
        this.bg = 'transparent';
      }
    },
  },
};
</script>
